import { render, staticRenderFns } from "./SignUpWizard.vue?vue&type=template&id=45b8b7dc&"
import script from "./SignUpWizard.vue?vue&type=script&lang=js&"
export * from "./SignUpWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports